import * as colors from './colors';
import * as fonts from './fonts';
import * as typography from './typography';
import breakpoints from './breakpoints';
import radii from './radii';
import shadows from './shadows';
import transition from './transition';

export const theme = {
  radii,
  breakpoints,
  colors,
  fonts,
  shadows,
  transition,
  typography,
};
